import { useParams } from 'react-router';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { Street } from '@/types';
import { useUpdateStreetMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface UpdateStreetProps extends DialogProps {
  street: Street;
  onClose(): void;
}

const UpdateStreet: React.FC<UpdateStreetProps> = ({ street, onClose, ...props }) => {
  const { regionId } = useParams<{ regionId: string }>();

  const { enqueueSnackbar } = useSnackbar();

  const [updateStreet, updateStreetResponse] = useUpdateStreetMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<Street>({
    initialValues: street ?? {
      name: '',
      parent_id: +regionId!,
    },
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(street, { resetForm }) {
      try {
        await updateStreet(street).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Редактировать улицу</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={updateStreetResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={updateStreetResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={updateStreetResponse.isLoading}>
            Редактировать
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UpdateStreet;
